import PropTypes from 'prop-types'

import AtomButton, {
  atomButtonColors,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'
import {useSuiContext} from '@s-ui/react-context'
import PrimitiveTypography, {primitiveTypographyDesign} from '@s-ui/react-primitive-typography'
import IconThumbDown from '@adv-mt/mt-svg-icons/lib/ThumbDown'
import IconThumbDownOutline from '@adv-mt/mt-svg-icons/lib/ThumbDownOutline'
import IconThumbUp from '@adv-mt/mt-svg-icons/lib/ThumbUp'
import IconThumbUpOutline from '@adv-mt/mt-svg-icons/lib/ThumbUpOutline'

const BASE_CARD_CLASS = 'mt-NetMessageList-messageReview'

const MessageReview = ({messageId, messageReaction, onReviewSuccess}) => {
  const {domain, i18n} = useSuiContext()

  const config = domain.get('config')
  const {FEEDBACK_REACTION_TYPES} = config.get('COMMON').AI_ASSISTANT
  const {POSITIVE, NEGATIVE} = FEEDBACK_REACTION_TYPES

  const onClickReaction = value => onReviewSuccess(messageId, value)

  return (
    <div className={BASE_CARD_CLASS}>
      <PrimitiveTypography design={primitiveTypographyDesign.BODY_1} className={`${BASE_CARD_CLASS}-label`}>
        {i18n.t('NET.FEEDBACK.REVIEW_MESSAGE')}
      </PrimitiveTypography>

      {messageReaction !== NEGATIVE && (
        <AtomButton
          color={atomButtonColors.PRIMARY}
          design={atomButtonDesigns.FLAT}
          disabled={messageReaction === POSITIVE}
          isFitted
          leftIcon={messageReaction === POSITIVE ? <IconThumbUp /> : <IconThumbUpOutline />}
          onClick={() => onClickReaction(POSITIVE)}
          shape={atomButtonShapes.CIRCULAR}
          size={atomButtonSizes.LARGE}
          className={`${BASE_CARD_CLASS}-iconButton`}
          aria-label={i18n.t('NET.FEEDBACK.REVIEW_POSITIVE_CTA_LABEL')}
        />
      )}
      {messageReaction !== POSITIVE && (
        <AtomButton
          color={atomButtonColors.PRIMARY}
          design={atomButtonDesigns.FLAT}
          disabled={messageReaction === NEGATIVE}
          isFitted
          leftIcon={messageReaction === NEGATIVE ? <IconThumbDown /> : <IconThumbDownOutline />}
          onClick={() => onClickReaction(NEGATIVE)}
          shape={atomButtonShapes.CIRCULAR}
          size={atomButtonSizes.LARGE}
          className={`${BASE_CARD_CLASS}-iconButton`}
          aria-label={i18n.t('NET.FEEDBACK.REVIEW_NEGATIVE_CTA_LABEL')}
        />
      )}
    </div>
  )
}

MessageReview.displayName = 'MessageReview'
MessageReview.propTypes = {
  messageId: PropTypes.string.isRequired,
  messageReaction: PropTypes.string,
  onReviewSuccess: PropTypes.func
}

export default MessageReview
